import React, { useEffect } from 'react'

import { digObject } from '@domain-group/javascript-utils'
import { Image } from '@domain-group/suit-theme'

import type { ArtworkPageModel, AttachmentModel } from '@models/types'

import useArtworkPagePreview from '@hooks/useArtworkPagePreview'
import type {
  UseArtworkPagePreviewOptions,
} from '@hooks/useArtworkPagePreview'

interface ArtworkPagePreviewProps {
  artworkPage: ArtworkPageModel,
  boxProps?: object,
  children: React.ReactElement | Function,
  configOptions: UseArtworkPagePreviewOptions,
  height: number | string,
  width: number | string,
}

const ArtworkPagePreview = (props: ArtworkPagePreviewProps) => {
  const {
    artworkPage = {},
    boxProps,
    children,
    configOptions,
    height,
    width,
  } = props

  const artworkPagePreviewPayload = useArtworkPagePreview(configOptions)
  const {
    attachment,
    buildingRef,
    callbacks: {
      buildPreview,
      setState,
    },
    selectedArtworkPageId,
  } = artworkPagePreviewPayload

  // Init
  useEffect(() => {
    // @ts-expect-error TS2339
    if (artworkPage.id && !selectedArtworkPageId){
      // @ts-expect-error TS2339
      setState({ selectedArtworkPageId: artworkPage.id })
    }
  // @ts-expect-error TS2339
  }, [artworkPage.id])

  // Refresh Page Preview
  useEffect(() => {
    if (
      buildPreview
      && !buildingRef.current
      // @ts-expect-error TS2339
      && artworkPage.template_page_id
      // @ts-expect-error TS2339
      && (!artworkPage.previews || (artworkPage.previews && artworkPage.previews.dirty))
    ){
      // @ts-expect-error TS2739
      buildPreview({ artworkPage })
    }
  // @ts-expect-error TS2339
  }, [artworkPage.template_page_id, artworkPage.previews])

  const imageUrl = digObject(attachment, 'links.thumb_url') || digObject(artworkPage, 'previews.thumb')

  const imageHeight = height ?? digObject(attachment, 'dimensions.thumb.height', 0)
  const imageWidth = width ?? digObject(attachment, 'dimensions.thumb.width', 0)

  return (
    <Image
      backgroundSize="contain"
      height={imageHeight}
      url={buildingRef.current ? null : imageUrl}
      width={imageWidth}
      {...boxProps}
    >
      {children && typeof children === 'function' && (
        children({
          attachment,
          buildingRef,
          height,
          width,
        })
      )}
    </Image>
  )
}

export type ArtworkPagePreviewRenderParams = {
  attachment: AttachmentModel,
  buildingRef: {
    current: boolean,
  },
  height: number,
  width: number,
}

export default ArtworkPagePreview
